<script setup lang="ts">
	import type { SelectItem } from '@nuxt/ui'

	const model = defineModel()

	const fontSizeOptions: SelectItem[] = [
		{ value: 'normal', label: 'Normal' },
		{ value: 'large', label: 'Groß' },
		{ value: 'xlarge', label: 'Sehr groß' },
		{ value: '2xlarge', label: 'Extra groß' },
	]
	const lineHeightOptions: SelectItem[] = [
		{ value: 'normal', label: 'Normal' },
		{ value: 'large', label: 'Erhöht' },
		{ value: 'xlarge', label: 'Stark erhöht' },
	]
	const letterSpacingOptions: SelectItem[] = [
		{ value: 'normal', label: 'Normal' },
		{ value: 'large', label: 'Erhöht' },
		{ value: 'xlarge', label: 'Stark erhöht' },
	]
	const contrastOptions: SelectItem[] = [
		{ value: 'standard', label: 'Standard' },
		{ value: 'high-light', label: 'Hochkontrast Hell' },
		{ value: 'high-dark', label: 'Hochkontrast Dunkel' },
	]
</script>

<template>
	<UForm class="flex flex-col gap-8">
		<fieldset class="flex flex-col gap-5">
			<legend class="font-bold text-xl mb-4">1. Lesbarkeit</legend>

			<UFormField label="Schriftgröße" name="fontSize">
				<USelect v-model="model.fontSize" :items="fontSizeOptions" class="w-full" size="xl" :ui="{ base: 'h-10', content: 'h-auto' }" />
			</UFormField>

			<UFormField label="Zeilenabstand" name="lineHeight">
				<USelect v-model="model.lineHeight" :items="lineHeightOptions" class="w-full" size="xl" :ui="{ base: 'h-10', content: 'h-auto' }" />
			</UFormField>

			<UFormField label="Buchstabenabstand" name="letterSpacing">
				<USelect v-model="model.letterSpacing" :items="letterSpacingOptions" class="w-full" size="xl" :ui="{ base: 'h-10', content: 'h-auto' }" />
			</UFormField>

			<UFormField name="boldText">
				<UCheckbox v-model="model.boldText" variant="list">
					<template #label>Fettschrift</template>
				</UCheckbox>
			</UFormField>

			<UFormField name="underlineLinks">
				<UCheckbox v-model="model.underlineLinks" variant="list">
					<template #label>Links unterstreichen</template>
				</UCheckbox>
			</UFormField>
		</fieldset>

		<fieldset class="flex flex-col gap-4">
			<legend class="font-bold text-xl mb-4">2. Darstellung</legend>

			<UFormField label="Kontrast" name="contrast">
				<USelect v-model="model.contrast" :items="contrastOptions" class="w-full" size="xl" :ui="{ base: 'h-10', content: 'h-auto' }" />
			</UFormField>

			<UFormField name="grayscale">
				<UCheckbox v-model="model.grayscale" variant="list">
					<template #label>Graustufen aktivieren</template>
				</UCheckbox>
			</UFormField>

			<UFormField name="hideImages">
				<UCheckbox v-model="model.hideImages" variant="list">
					<template #label>Bilder ausblenden</template>
				</UCheckbox>
			</UFormField>
		</fieldset>
	</UForm>
</template>
